import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { Link } from '@americanexpress/dls-react';
import styles from './TravelCreditTab.scss';
import { useIsCenturionContext } from '../../context/isCenturionContext';
import getLocalisedDateFromString from '../../utils/getLocalisedDateFromStringUtil';
import { getCardArt, getFormattedAccountNumber } from '../../utils/membershipDataUtils';

const TravelCreditDetail = ({
  membershipData,
  selectedTravelCredit,
  hasTravelCreditCenturionCardArt,
}) => {
  const { formatMessage } = useIntl();
  const {
    awardName: name,
    awardDescription: marketingText,
    landingPage: ctaLink,
    callToActionText: ctaText,
    expiryDate: expiry,
  } = selectedTravelCredit;

  const activeLocale = useSelector(getActiveLocaleSelector);
  const formattedExpiryDate = getLocalisedDateFromString(
    expiry,
    activeLocale
  );
  const formattedAccountNumber = getFormattedAccountNumber(membershipData);
  const isCenturion = useIsCenturionContext();

  const cardArt = getCardArt(membershipData);

  const hasCardArt = isCenturion
    ? hasTravelCreditCenturionCardArt && !!cardArt
    : !!cardArt;
  return (
    <>
      <div id="travelCredit_cardInfo" className="flex margin-2-b margin-2-t">
        {hasCardArt && (
          <img
            src={cardArt}
            alt={formatMessage({ id: 'cardArt' })}
            className={clsx(styles.cardArt, 'margin-2-r')}
          />
        )}
        <div>
          {name && (
            <span
              className="font-weight-medium"
              // eslint-disable-next-line react/no-danger -- data from oneCMS
              dangerouslySetInnerHTML={{ __html: name }}
            />
          )}
          <p className={styles.creditDetail}>
            {formattedAccountNumber && (
              <span>
                {formatMessage({ id: 'travelCreditTab.cardNumber' })}{' '}
                {formattedAccountNumber}{' '}
              </span>
            )}

            {formattedExpiryDate && (
              <span>
                <span className="hidden-sm-down"> | </span>
                {formatMessage({ id: 'travelCreditTab.expiry' })}{' '}
                {formattedExpiryDate}
              </span>
            )}
          </p>
        </div>
      </div>
      <p>
        {/* eslint-disable-next-line react/no-danger -- data from oneCMS */}
        <span dangerouslySetInnerHTML={{ __html: sanitize(marketingText) }} />
        {ctaLink && ctaText && (
          <Link
            href={ctaLink}
            rel="noopener noreferrer"
            reactlytics={{
              element: 'hp-travelCreditTab',
              detail: 'showTravelCreditLearnMore',
            }}
          >
            {ctaText}
          </Link>
        )}
      </p>
    </>
  );
};

TravelCreditDetail.propTypes = {
  membershipData: PropTypes.shape({
    demographics: PropTypes.shape({
      product: PropTypes.shape({
        cardArtCdnLink: PropTypes.string,
      }),
    }),
  }),
  selectedTravelCredit: PropTypes.shape({
    awardName: PropTypes.string,
    awardDescription: PropTypes.string,
    landingPage: PropTypes.string,
    callToActionText: PropTypes.string,
    expiryDate: PropTypes.string,
  }),
  hasTravelCreditCenturionCardArt: PropTypes.bool.isRequired,
};

export default TravelCreditDetail;
